import React, { Component, ErrorInfo, ReactNode } from 'react';
import { reportAppError } from '../../utils/errorReport';

type AppErrorBoundaryProps = {
  children: ReactNode;
};

type AppErrorBoundaryState = {
  hasError: boolean;
};

class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    reportAppError('אירעה שגיאה לא צפויה באפליקציה', {
      action: 'React render error',
      error,
      context: {
        componentStack: info.componentStack,
      },
    });
  }

  render() {
    return this.props.children;
  }
}

export default AppErrorBoundary;
